import API from 'services/TAPS_API';

export default function getTaxAuthorities(regionId) {
  return API.request({
    method: 'GET',
    url: `/dictionary/taxauthority?startWith=${regionId}`,
  });
}
